import { pdf } from '@react-pdf/renderer';
import { InvoiceDocument } from '../InvoicePdf/InvoicePdf';

interface InvoicePdfGeneratorProps {
  onError: (message: string) => void;
  onComplete?: () => void;
}

export interface InvoiceData {
  invoiceNumber: string;
  issueDate: string;
  companyName: string;
  companyAddress: string;
  vatNumber: string;
  email: string;
  contactNumber: string;
  gensetPrice: number;
  clientAddress: string;
  loadDetails: {
    loadNumber: string;
    containerNumber: string;
    loadDate: string;
    loadPoint1: string;
    loadPoint2: string;
  };
  items: any[];
  notes: string;
  totalAmount: number;
}

export const generateAndDownloadInvoice = async (
  invoiceNumber: string,
  invoiceData: InvoiceData,
  callbacks: InvoicePdfGeneratorProps
) => {
  try {
    const blob = pdf(<InvoiceDocument invoiceNumber={invoiceNumber} invoiceData={invoiceData} />).toBlob();

    blob.then((pdfBlob) => {
      const url = URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Invoice-${invoiceNumber}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      if (callbacks.onComplete) {
        callbacks.onComplete();
      }
    }).catch((err) => {
      console.error("Error generating PDF:", err);
      callbacks.onError('Failed to generate invoice PDF');
    });
  } catch (err) {
    console.error("Error in PDF generation:", err);
    callbacks.onError('Failed to generate invoice PDF');
  }
};

export default generateAndDownloadInvoice; 